const doc = [({"en":({"js":({"components":({"audits":({"table":({"no_model_for_model_type":"No model for %{model_type} %{model_id}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;